import { render } from "./CategoryManagement.vue?vue&type=template&id=27f44820&scoped=true"
import script from "./CategoryManagement.vue?vue&type=script&lang=js"
export * from "./CategoryManagement.vue?vue&type=script&lang=js"

import "./CategoryManagement.vue?vue&type=style&index=0&id=27f44820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f44820"]])

export default __exports__